import React from 'react';
import ItemToken from "./item-token.jsx";

const QuerySummary = ({selectedItems, periodLabel, applied, countTarget, onEdit, onSearch, searchDisabled}) => {
    const hasItems = selectedItems.length > 0;

    const formatBadge = (key) => {
        if (!applied) return "—";
        return countTarget[key] ?? 0;
    };

    return (
        <div className="bg-white border border-[#dfe5ec] rounded-xl overflow-hidden">
            <div className="px-3.5 pt-3 pb-2.5">
                <div className="flex items-baseline justify-between mb-2">
                    <span className="text-[11px] font-semibold tracking-[0.1em] uppercase text-[#6b7a92]">Consulta atual</span>
                    {periodLabel && <span className="font-mono text-[10px] text-[#98a3b2]">{periodLabel}</span>}
                </div>

                {
                    hasItems
                        ? selectedItems.map(item => (
                            <div key={item.key} className="flex items-center gap-2.5 py-1">
                                <ItemToken item={item}/>
                                <span className="flex-1 min-w-0 truncate text-[13px] font-medium text-[#16233a]">{item.name}</span>
                                <span className={["flex-none font-mono text-[12px] font-medium", applied ? "text-[#16233a]" : "text-[#c2cad6]"].join(" ")}>
                                    {formatBadge(item.key)}
                                </span>
                            </div>
                        ))
                        : <div className="text-[13px] text-[#98a3b2] py-1">Nenhum item de análise definido.</div>
                }
            </div>

            <div className="flex border-t border-[#edf1f5]">
                <button
                    onClick={onEdit}
                    className="flex-1 h-10 text-[13px] font-medium text-[#16233a] cursor-pointer transition-colors hover:bg-[#f7f9fb]"
                >
                    Editar consulta
                </button>
                <button
                    onClick={onSearch}
                    disabled={searchDisabled}
                    className={["flex-1 h-10 border-l border-[#edf1f5] text-[13px] font-semibold transition-colors",
                        searchDisabled
                            ? "bg-[#eef2f7] text-[#a9b3c1] cursor-not-allowed"
                            : "bg-[#063A6C] text-white cursor-pointer hover:bg-blue-800"].join(" ")}
                >
                    Pesquisar
                </button>
            </div>
        </div>
    );
};

export default QuerySummary;
